const isHml = window?.location?.href?.includes("hml");

const PAYFAC_BASE = isHml ? `/hml-payfac/` : `/payfac/`;

const PAYFAC_PENDENCIES = `pendencies`;
const PAYFAC_RATE_PLANS = `rate_plans`;
const PAYFAC_RATES = `rates`;
const PAYFAC_REPORTS = `reports`;
const PAYFAC_SELLERS = `sellers`;
const PAYFAC_TRANSACTIONS = `transactions`;
const PAYFAC_DASHBOARD_INDICATORS = `resume`;
const PAYFAC_DASHBOARD_TERMINALS = `terminals_dashboard`;
const PAYFAC_DASHBOARD_COMMISSIONS = `comission_dashboard`;

export const ROUTES_PAYFAC = {
  path: PAYFAC_BASE,
  fullPath: PAYFAC_BASE,

  DEV: {
    path: "dev",
    fullPath: `${PAYFAC_BASE}dev`,
  },

  PENDENCIES: {
    path: PAYFAC_PENDENCIES,
    fullPath: `${PAYFAC_BASE}${PAYFAC_PENDENCIES}`,
  },

  RATES: {
    path: PAYFAC_RATES,
    fullPath: `${PAYFAC_BASE}${PAYFAC_RATES}`,
    fullPathWithSeller: (idSeller: string | number) =>
      `${PAYFAC_BASE}${PAYFAC_RATES}?idSeller=${idSeller}`,
  },

  REPORTS: {
    path: PAYFAC_REPORTS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_REPORTS}`,
  },

  TRANSACTIONS: {
    path: PAYFAC_TRANSACTIONS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_TRANSACTIONS}`,
  },

  DASHBOARD_INDICATORS: {
    path: PAYFAC_DASHBOARD_INDICATORS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_DASHBOARD_INDICATORS}`,
  },

  DASHBOARD_TERMINALS: {
    path: PAYFAC_DASHBOARD_TERMINALS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_DASHBOARD_TERMINALS}`,
  },

  DASHBOARD_COMMISSIONS: {
    path: PAYFAC_DASHBOARD_COMMISSIONS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_DASHBOARD_COMMISSIONS}`,
  },

  RATE_PLANS: {
    path: PAYFAC_RATE_PLANS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_RATE_PLANS}`,

    FORM: {
      path: `${PAYFAC_RATE_PLANS}/form`,
      fullPath: `${PAYFAC_BASE}${PAYFAC_RATE_PLANS}/form`,
    },

    SHOW: {
      path: `${PAYFAC_RATE_PLANS}/:id`,
      fullPath: (id: number) => `${PAYFAC_BASE}${PAYFAC_RATE_PLANS}/${id}`,
    },
  },

  SELLERS: {
    path: PAYFAC_SELLERS,
    fullPath: `${PAYFAC_BASE}${PAYFAC_SELLERS}`,
  },
};

const LEGACY_WEBAPP_BASE = `https://webapp.barte.com`;
const LEGACY_WEBAPP_APP_BASE = `${LEGACY_WEBAPP_BASE}/app/`;

export const ROUTES_LEGACY_WEBAPP = {
  path: LEGACY_WEBAPP_APP_BASE,
  fullPath: LEGACY_WEBAPP_APP_BASE,

  DASHBOARD: {
    path: "",
    fullPath: LEGACY_WEBAPP_APP_BASE,
    INDICATORS: {
      path: "resume",
      fullPath: `${LEGACY_WEBAPP_APP_BASE}resume`,
    },
    TERMINALS: {
      path: "terminals_dashboard",
      fullPath: `${LEGACY_WEBAPP_APP_BASE}terminals_dashboard`,
    },
    COMMISSIONS: {
      path: "comission_dashboard",
      fullPath: `${LEGACY_WEBAPP_APP_BASE}comission_dashboard`,
    },
  },
  SELLERS: {
    path: "sellers",
    fullPath: `${LEGACY_WEBAPP_APP_BASE}sellers`,
    SHOW: {
      fullPath: (id: string | number) =>
        `${LEGACY_WEBAPP_APP_BASE}sellers/${id}`,
    },
    CREATE: {
      fullPath: `${LEGACY_WEBAPP_APP_BASE}sellers/create`,
    },
    UPDATE: {
      fullPath: (id: string | number) =>
        `${LEGACY_WEBAPP_APP_BASE}sellers/update/${id}`,
    },
    EDIT_TAXES: {
      fullPath: (id: string | number) =>
        `${LEGACY_WEBAPP_APP_BASE}sellers/${id}?taxes=edit`,
    },
  },
  TRANSACTIONS: {
    path: "transactions",
    fullPath: `${LEGACY_WEBAPP_APP_BASE}transactions`,
  },
  CHARGEBACKS: {
    path: "chargebacks",
    fullPath: `${LEGACY_WEBAPP_APP_BASE}chargebacks`,
  },
  REPORTS: {
    path: "reports",
    fullPath: `${LEGACY_WEBAPP_APP_BASE}reports`,
  },

  CHOOSE_COMPANY: {
    fullPath: `${LEGACY_WEBAPP_BASE}/choose-company`,
  },
  BACKOFFICE: {
    fullPath: `${LEGACY_WEBAPP_BASE}/backoffice`,
  },
  LOGOUT: {
    fullPath: `${LEGACY_WEBAPP_BASE}/logout`,
  },
};
